import {asQueryString} from '@wallaby-ui/core';
import {
  ALERT_COMPONENT_HOSPITALIZATION_LIST,
  ALERT_COMPONENT_PHARMACOTHERAPY_RECOMMENDATION_LIST,
  AlertEpisodeRowDto,
} from '@wallaby-ui/document';

import {RIGHT_TAB_ALERTS, RIGHT_TAB_PH_RECOMMENDATION} from '../hospitalizations_detail/hospitalizationRightTabs';

/**
 * Where an alert name leads, by the alert's list (PDW-405): the hospitalization with its Alerts tab showing the episode,
 * or the hospitalization of a pharmacotherapy recommendation with that recommendation opened. An unknown list or a
 * missing hospitalization has no link. The alerts list and the Alerts panel's Elsewhere group share it (PDW-436).
 */
export function alertEpisodeHref(episode: AlertEpisodeRowDto): string | null {
  if (!episode.anchorAvailable) return null;
  if (episode.component === ALERT_COMPONENT_HOSPITALIZATION_LIST) {
    return `/hospitalizedPatients/v2/${episode.anchorId}?${asQueryString({
      rightTabs: RIGHT_TAB_ALERTS,
      alertItem: {focusedEpisodeId: episode.episodeId},
    })}`;
  }
  if (episode.component === ALERT_COMPONENT_PHARMACOTHERAPY_RECOMMENDATION_LIST) {
    const encounterId = episode.anchorProperties.evaluatedEncounterId;
    if (encounterId == null) return null;
    return `/hospitalizedPatients/v2/${encounterId}?${asQueryString({
      rightTabs: RIGHT_TAB_PH_RECOMMENDATION,
      phRecItem: {openedItemId: episode.anchorId},
    })}`;
  }
  return null;
}
